// Email
export const invalidEmail = 'validation.invalidEmail'
// Username
export const tooShortUsername = 'Username must be at least 2 characters.'
